import { useQuery } from '@tanstack/react-query';
import { getRegistrar } from 'API/TRSRegistrar/getRegistrar';

const useGetRegistrar = (registrarId, enabled = true) => {
    return useQuery({
        queryKey: ['Registrar', registrarId],
        queryFn: async () => {
            try {
                const response = await getRegistrar(registrarId);
                return response.data;
            } catch (error) {
                console.error('Error fetching registrar:', error);
                throw error;
            }
        },
        enabled: enabled && !!registrarId,
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 2,
        refetchOnWindowFocus: false,
    });
};

export default useGetRegistrar;
